import { css } from '@emotion/core'

export const styles = {
  container: css`
    display: flex;
    flex-direction: column;

    &:not(:first-child) {
      margin-top: 18px;
    }
  `,

  disabled: css`
    opacity: 0.75;
    pointer-events: none;
  `,

  label: css`
    font-size: 12px;
    text-transform: uppercase;
    font-weight: 600;
    user-select: none;
  `,

  required: css`
    font-size: 10px;
    color: #c0392b;
    opacity: 0.75;

    vertical-align: text-top;
    line-height: 150%;
  `,

  content: css`
    margin-top: 8px !important;
    height: 35px;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;

    > div {
      flex: 1;
      margin-bottom: 2px;
    }
  `,
}
